import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { JGRNService } from "../../../services/index";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
import { ReturnService } from "../../../services/return.service";
import { GrnService } from "../../../services/grn.service";
import { PrintData } from "../../master/print/print";



declare var google;

@Component({
  selector: "non-ordered-design-list",
  templateUrl: "./nonOrderedDesignList.html",
})
export class nonOrderedDesignList implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  selected = [];
  isLoading: boolean = false;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  saveEvent: any;
  acceptReturn : string;
  accept_po_no : number = 0;
  return_reason : string = '';
  printData;


  design_no : any;
  filter = {
    groupby: "party",
    party_id: "",
    type : "",
    ref_id: "",
    ref_no : "",
    party_code : ""
  };
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "ref_no",
    orderDir: "desc",
  };
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("separateBitTemplate") separateBitTemplate: TemplateRef<any>;
  @ViewChild("typeAuto") typeAuto;
  @ViewChild("barcodeAuto") barcodeAuto;
  @ViewChild("designListAuto") designListAuto;

  sel_bits: number = 0;
  tot_mtrs: number = 0;
  splitData = {
    no_of_bits: 0,
  };
  totalMtrs: number = 0;
  splitArray: any;
  data: any;
  splitRowDetails = [];
  rowDetails : any;
  splitLength: number = 0;
  columns = [];
  toggleCol = [];
  barcodeDesignList = [];
  barcodeList = [];
  designList = [];
  menu: any;
  reportName = "design_no";
  bsModalRef: BsModalRef;
  reportType = "Design";
  user: any;
  total_mtrs: number = 0;
  total_amt: number = 0;
  total_qty: number = 0;
  total_bits: number = 0;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private jgrnService: JGRNService,
    private returnservice: ReturnService,
    public toasterService: ToasterService,
    private modalService: BsModalService,
    private grn: GrnService,
    private poservice: PurchaseOrderService

  ) {
    this.data = {
      jgrnList: [],
    };
  }

  ngOnInit(): void {
    this.getColumns();
    // this.getBarcodeDesign();
    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    if (this.filter.groupby == "party") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Party name",
          prop: "party_name",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "Party code",
          prop: "party_code",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Tot.mtrs",
          prop: "tot_mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.amount",
          prop: "tot_amount",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    } else if (this.filter.groupby == "type") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Pending In",
          prop: "pending_type",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Party name",
          prop: "party_name",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "Party code",
          prop: "party_code",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
       
        {
          name: "Tot.mtrs",
          prop: "tot_mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.amount",
          prop: "tot_amount",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    } else if (this.filter.groupby == "ref_no" && this.filter.type == "SAMPLE GRN") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Grn no",
          prop: "ref_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 140,
          maxWidth: 140,
          width: 140,
        },
        {
          name: "Grn date",
          prop: "ref_date",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Po no",
          prop: "po_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Tot.mtrs",
          prop: "tot_mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.amount",
          prop: "tot_amount",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },  
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    } else if (this.filter.groupby == "ref_no" && this.filter.type == "INVOICE") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Inv ref no",
          prop: "ref_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 140,
          maxWidth: 140,
          width: 140,
        },
        {
          name: "Inv date",
          prop: "ref_date",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Po no",
          prop: "po_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Tot.mtrs",
          prop: "tot_mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.amount",
          prop: "tot_amount",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },  
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    } else {
      this.columns = [
        {
          prop: "selected",
          name: "",
          sortable: false,
          canAutoResize: false,
          draggable: false,
          resizable: false,
          headerCheckboxable: true,
          checkboxable: true,
          width: 30,
        },
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Party design",
          prop: "party_design",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Party shade",
          prop: "party_shade",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Fab Style",
          prop: "fab_style",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },

        {
          name: "Width",
          prop: "bitwidth",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Quality",
          prop: "quality",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.mtrs",
          prop: "tot_mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.amount",
          prop: "tot_amount",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },  
      ];
    }

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;

    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getOrderList();
  }

  clearFilter(): void {
    this.applyFilter();
  }

  applyFilter(): void {
    this.getColumns();
  }
  applyFilterView(row) {
    if (this.filter.groupby == "ref_no") {
      this.filter.groupby = "design_no";
      this.filter.party_id = row.party_id;
      this.filter.type = row.pending_type;
      this.filter.ref_id = row.ref_id;
      this.filter.ref_no = row.ref_no;
      this.rowDetails = row;
    }
    if (this.filter.groupby == "type") {
      this.filter.groupby = "ref_no";
      this.filter.party_id = row.party_id;
      this.filter.type = row.pending_type;
    }
    if (this.filter.groupby == "party") {
      this.filter.groupby = "type";
      this.filter.party_id = row.party_id;
      this.filter.party_code = row.party_code;
    }
    this.getColumns();
  }
  gobacktoffGroup() {
    if (this.selected.length > 0) {
      swal("Please deselect all before going back");
      return;
    }
    if (this.filter.groupby == "type") {
      this.filter.groupby = "party";
      this.filter.party_id = "";
    }

    if (this.filter.groupby == "ref_no") {
      this.filter.groupby = "type";
      this.filter.type = '';
    }

    if (this.filter.groupby == "design_no") {
      this.filter.groupby = "ref_no";
      this.filter.ref_id = '';
      this.rowDetails = [];
    }


    this.getColumns();
  }
  onEnterNoOfBits(bits) {
    this.splitArray = Array(bits).fill(bits);
  }
  splitRow(row) {
    this.splitData = {
      no_of_bits: 0,
    };
    this.totalMtrs = 0;
    this.splitArray = [];
    this.splitRowDetails = [];
    this.splitLength = 0;

    this.splitRowDetails = row;
    this.splitLength = Object.keys(this.splitRowDetails).length;
  }
  getOrderList(): void {
    let params = {
      start: `${this.page.offset * this.page.limit}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      //order_from_date:this.filter.order_from_date
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    that.isLoadMask = this.poservice
      .getNonOrderedDesignList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.total_mtrs = 0;
        that.total_amt = 0;

        
          that.orderList.forEach((el) => {
            that.total_mtrs += el.tot_mtrs;
            that.total_amt += el.tot_amount;
          });
        that.total_mtrs =
          Math.round((that.total_mtrs + Number.EPSILON) * 100) / 100;
        that.total_amt =
          Math.round((that.total_amt + Number.EPSILON) * 100) / 100;
      });
  }

  

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    console.log(this.selected);

    this.tot_mtrs = 0;
    this.sel_bits = 0;

    this.selected.forEach((el) => {
      this.tot_mtrs += el.avl_mtrs;
    });
    this.tot_mtrs = Math.round((this.tot_mtrs + Number.EPSILON) * 100) / 100;
    this.sel_bits = this.selected.length;
  }
  getId(row) {
    return row.ref_det_id;
  }
  getIdFunction() {
    return this.getId.bind(this);
  }
  onsubmitAcceptReturn(mode){
    this.acceptReturn = mode;
  }
  onSubmitReturnAccept(mode) {
    if (this.selected.length > 0) {
      let params = {
        rowDetails: JSON.stringify(this.rowDetails),
        selected: JSON.stringify(this.selected),
        mode : mode,
        accept_po_no : this.accept_po_no,
        return_reason : this.return_reason
      };
      let that = this;
      that.isLoadMask = that.poservice
      .onSubmitReturnAccept(params)
      .then(function (res : any) {

        if(!res.success){
          swal("Please add designs and shade in PO and then proceed");
          return;
        }else{
          if(mode == 'accept'){
            if(that.filter.type == 'SAMPLE GRN'){
              swal({
                title: "Click Yes to print barcode  sticker?",
                type: "info",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "Later",
              }).then(() => {
                that.loadeditgrnlist(that.rowDetails, res.accept_return_ref_no);
              }).catch(() => {
                that.reopenTab();
              });
            }else{
              swal("Accepted successfuly");
              that.reopenTab();
              
            }

          }else{

            swal({
              title: "Click Yes to print?",
              type: "info",
              showCancelButton: true,
              confirmButtonText: "Yes",
              cancelButtonText: "Later",
            }).then(() => {
              swal("Accepted successfuly");
              that.printInvoiceRet(that.rowDetails, res.accept_return_ref_no);
            }).catch(() => {
              that.reopenTab();
            });
            
          }
          
        }
        
      }).catch(() => {
        that.reopenTab();
      });
    } else {
      swal("Select atleast one design");
    }
  }

  reopenTab(){
    this.accept_po_no = 0;
    this.return_reason = '';
    let that = this;
    let tabObj = {
      action: "CloseTab",
      params: {},
    };
    that.tabUpdateEvent.emit(tabObj);

    let tabObj1 = {
      action: "NewTab",
      params: {
        tabParent: "CLOTH",
        tabName: "NON-ORDERED PO DESIGN",
        id: "nonOrderedDesignList",
        name: "NON-ORDERED PO DESIGN"
      },
    };

    that.tabUpdateEvent.emit(tabObj1);
  }

    printInvoiceRet(row,accept_return_ref_no) {
    delete row.tabevent;
    let params = {
      printType: "purchaseInvoiceNonOrderReturn",
      data : JSON.stringify(row),
      accept_return_ref_no : accept_return_ref_no
    };
    this.returnservice.purchaseInvoiceReturnPrint(params).then((res: any) => {
      
      this.printData = res;

      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70"
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printcontent = this.printData;
      this.reopenTab();
      
    });
  }

   loadeditgrnlist(row, accept_return_ref_no) {
    let params = {
      grn_id: this.filter.ref_id,
      accept_return_ref_no : accept_return_ref_no
    };
    this.grn.getEditNonOrderedGrnList(params).then((res: any) => {
      this.clickPrint(row, res.data);
      this.data.grnList = res.data;
      this.design_no = res.design_no - 1;
      swal("Accepted successfuly");
    });
  }

  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.grn.grnprint(params).then(function (res: any) {});
    that.reopenTab();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/invoice/nonOrderedDesignList.ts